import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import { useSelector } from "react-redux";
import "./SearchPage.scss";

const SearchPage = () => {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const [searchKeyword, setSearchKeyword] = useState([]);
  const [titleBookmark, setTitleBookmark] = useState([]);
  const { value } = useParams();
  // const navigate = useNavigate();
  var host = window.location.host;
  var protocol = window.location.protocol;
  useEffect(() => {
    axios
      .get(api.manual.search, { params: { search: value } })
      .then((res) => {
        setSearchKeyword(res.data.searchKeyword);
        setTitleBookmark(res.data.titleBookmark);
      })
      .catch((error) => console.log(error));
  }, [value]);
  return (
    <div className="search-main">
      <h3>
        <span className="search-word">'{value}'</span> 검색 결과
      </h3>
      <div className="search-keyword-container">
        <div className="search-label">
          키워드 검색 :{" "}
          <span className="search-count">'{searchKeyword?.length}'</span> 건
        </div>
        <table className="search-keyword-table">
          <thead>
            <tr>
              <th> </th>
              <th>매뉴</th>
              <th>문서명</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {searchKeyword?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index}</td>
                  <td>
                    {item.path[0]} {">"} {item.path[1]}
                  </td>
                  <td>
                    <Link to={`${protocol}//${host}/${manualType}${item.url}`}>
                      <span className="search-keyword-table-title">
                        {item.title}
                      </span>
                    </Link>
                  </td>
                  <td></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="search-title">
        <div className="search-label">
          문서명/목차 검색 :{" "}
          <span className="search-count">'{titleBookmark?.length}'</span> 건
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>매뉴</th>
              <th>문서명</th>
              <th>목차</th>
            </tr>
          </thead>
          <tbody>
            {titleBookmark?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index}</td>
                  <td>
                    {item.path[0]} {">"} {item.path[1]}
                  </td>
                  <td>
                    <Link to={`${protocol}//${host}/${manualType}${item.url}`}>
                      <span className="search-title-table-title">
                        {item.title}
                      </span>
                    </Link>
                  </td>
                  <td>
                    <ul>
                      {item?.bookmark?.map((subtitle, index) => {
                        return (
                          <Link
                            className="bookmark-link"
                            to={`${protocol}//${host}/${manualType}${item.url}`}
                            key={index}
                          >
                            <li
                            // onClick={() => {
                            //   navigate(`${protocol}//${host}/${manualType}${item.url}`);
                            // }}
                            >
                              {subtitle}
                            </li>
                          </Link>
                        );
                      })}
                    </ul>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SearchPage;
